import { observable, computed, makeObservable } from 'mobx';
import { EventManager } from '@searchspring/snap-event-manager';
export class CartStore {
    constructor() {
        this.items = [];
        makeObservable(this, {
            items: observable,
            price: computed,
            count: computed,
            msrp: computed,
        });
        this.eventManager = new EventManager();
    }
    on(event, ...func) {
        this.eventManager.on(event, ...func);
    }
    get count() {
        let count = 0;
        this.items.forEach((item) => {
            count += item.quantity;
        });
        return count;
    }
    get price() {
        let price = 0;
        this.items.forEach((item) => {
            price += +(item.display.mappings.core?.price || 0) * item.quantity;
        });
        return price;
    }
    get msrp() {
        let price = 0;
        this.items.forEach((item) => {
            price += (+(item.display.mappings.core?.msrp || 0) || +(item.display.mappings.core?.price || 0) || 0) * item.quantity;
        });
        return price;
    }
    addItems(items) {
        items.forEach((item) => {
            const idx = this.items.findIndex((result) => result.id == item.id);
            //is it in the items list?
            if (idx == -1) {
                this.items.push(item);
            }
        });
        this.eventManager.fire('addItems', { cart: this, items });
    }
    removeItems(items) {
        const newIds = [...this.items];
        items.forEach((item) => {
            const idx = newIds.findIndex((result) => result.id == item.id);
            //is it in the selected items?
            if (idx > -1) {
                // remove it entirely
                newIds.splice(idx, 1);
                // when emptied fire empty event
                if (newIds.length == 0) {
                    this.eventManager.fire('emptied', { cart: this });
                }
            }
        });
        this.items = newIds;
        this.eventManager.fire('removeItems', { cart: this, items });
    }
    reset() {
        this.items = [];
        this.eventManager.fire('reset', { cart: this });
    }
}
